module.exports = __webpack_public_path__ + "img/media-1.6729316c.png";